module.exports = __webpack_public_path__ + "static/media/sub-text.f9e377ad.png";


//////////////////
// WEBPACK FOOTER
// ./public/sub-text.png
// module id = 193
// module chunks = 0